import MainSharedComponent, {
    MainImgTextSharedComponentElType,
} from "@components/severalbrands/ourStoryPage/mainSharedComponent";

const defaultGrowthList: MainImgTextSharedComponentElType[] = [
    {
        img: "/severalbrands/assets/images/unlockBusinessSuccessB2b2.webp",
        mainTitle:
            "Maximize Your Firm's Growth with Multifaceted Marketing Strategies",
        secondTitle: "SEO & SEM",

        paragraphs: [
            "SEO provides sustainable growth and revenue enhancement at no extra cost but might not scale quickly. To accelerate our clients' growth, we integrate SEM tactics. This strategy includes a specialized team for SEO content development and a robust team of over 20 SEM professionals managing paid campaigns across Google, Bing, and Yahoo. This dual approach ensures our digital marketing efforts are both effective and comprehensive.",
        ],

        mainSectionClassName: `3xl:gap-[200px] lg:gap-[130px] gap-[40px] lg:ml-16 3xl:ml-20`,
        mainTitleClassName: "text-[#351C4F]",
        secondTitleClassName: "mt-[20px] text-[#351C4F]",
        imgClassName:
            "w-[250px]  h-[250px] md:w-[420px] md:min-w-[420px] md:h-[420px] relative 3xl:w-[620px] 3xl:min-w-[620px] 3xl:h-[620px] lg:mt-10 lg:ml-16 3xl:ml-28",
    },

    {
        img: "/severalbrands/assets/images/displayAdvertisingB2b.png",
        mainTitle: "Innovative Display Advertising",
        paragraphs: [
            "Our display advertising strategy employs a variety of platforms, incorporating the Google Display Network, native advertising with Taboola and Outbrain, PPV campaigns, and other external networks. With more than ten years in the field, we have honed our techniques to optimize conversion rates and deliver superior campaign performance consistently.",
        ],
        mainSectionClassName: `lg:gap-[210px] gap-[40px] lg:ml-16 3xl:ml-28 `,

        mainTitleClassName: "text-[#351C4F] 3xl:mt-[60px]",
        imgToLeft: true,
        imgClassName:
            "w-[250px]  h-[200px] md:w-[458px] md:min-w-[458px] md:h-[312px] relative 3xl:w-[630px] 3xl:min-w-[630px] 3xl:h-[554px]",
    },

    {
        img: "/severalbrands/assets/images/localizationB2b2.webp",
        mainTitle: "Strategic Localization:",
        paragraphs: [
            "Localization is a critical strategy for effectively reaching global markets or multilingual audiences. For instance, law firms in the US targeting both English and Spanish speakers can significantly benefit from this approach.",
        ],
        mainSectionClassName: `3xl:gap-[210px] lg:gap-[150px]  gap-[40px]  lg:ml-16 3xl:ml-20`,
        secondSectionClassName: "",
        mainTitleClassName: "text-[#351C4F] lg:mt-10",

        imgClassName:
            "w-[250px]  h-[250px] md:w-[392px] md:min-w-[392px] md:h-[392px] 3xl:w-[592px] 3xl:min-w-[592px] 3xl:h-[592px]  relative lg:ml-16 3xl:ml-28",
    },
];

export default function MaximizeFirmGrowth({
    list = defaultGrowthList,
}: {
    list?: MainImgTextSharedComponentElType[];
}) {
    return (
        <section className={`lg:my-32 my-16`}>
            {list.map((el, index) => (
                <div className="lg:mt-36 mt-14 first-of-type:mt-0" key={index}>
                    <MainSharedComponent info={el} />
                </div>
            ))}
        </section>
    );
}
